"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationProvider = NotificationProvider;
exports.useNotification = useNotification;
var _react = _interopRequireWildcard(require("react"));
var _loader2x = _interopRequireDefault(require("../../assets/images/loader@2x.gif"));
var _check = _interopRequireDefault(require("../../assets/images/check.svg"));
var _error = _interopRequireDefault(require("../../assets/images/error.svg"));
var _info = _interopRequireDefault(require("../../assets/images/info.svg"));
var _warning = _interopRequireDefault(require("../../assets/images/warning.svg"));
var _core = require("../../services/core/core.service");
var _Socket = require("../webSocket/Socket");
var _SocketContainer = _interopRequireDefault(require("../webSocket/SocketContainer"));
var _NotificationContainer = _interopRequireDefault(require("./NotificationContainer"));
var _reactRedux = require("react-redux");
require("./Notification.scss");
var _actions = require("../../redux/tenant/actions");
var _actions2 = require("../../redux/dashboard/actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AuthContext = /*#__PURE__*/(0, _react.createContext)();
var closeTime = 1000 * 60 * 24 * 30;
var crypto = window.crypto || window.msCrypto;
function NotificationProvider(props) {
  var position = props.position,
    dismissTime = props.dismissTime,
    children = props.children;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isloading = _useState4[0],
    setisloading = _useState4[1];
  var _useState5 = (0, _react.useState)(dismissTime || 3000),
    _useState6 = _slicedToArray(_useState5, 2),
    autoClose = _useState6[0],
    setAutoClose = _useState6[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      var _state$socket, _state$socket2;
      return {
        allStates: state,
        loadingList: state === null || state === void 0 ? void 0 : (_state$socket = state.socket) === null || _state$socket === void 0 ? void 0 : _state$socket.loadingList,
        loadingListForRecord: state === null || state === void 0 ? void 0 : (_state$socket2 = state.socket) === null || _state$socket2 === void 0 ? void 0 : _state$socket2.loadingListForRecord
      };
    }),
    allStates = _useSelector.allStates,
    loadingList = _useSelector.loadingList,
    loadingListForRecord = _useSelector.loadingListForRecord;
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      if (list.length) {
        deleteToast(list[0].id);
      }
    }, autoClose ? autoClose : closeTime);
    return function () {
      clearInterval(interval);
    };
  }, [list]);
  var deleteToast = function deleteToast(newId) {
    if (newId) {
      var listItemIndex = list.findIndex(function (e) {
        return e.id === newId;
      });
      list.splice(listItemIndex, 1);
      setList(_toConsumableArray(list));
    } else {
      setList([]);
    }
  };
  var id = Math.floor(crypto.getRandomValues(new Uint32Array(1)));
  var toastProperties = null;
  var Loader = {
    display: function display(loading) {
      setisloading(loading);
    }
  };
  var handleActions = {};
  if (process.env.REACT_APP_CLIENT === "dashboard") {
    handleActions = {
      socketResponse: function socketResponse(payload) {
        return dispatch((0, _actions2.socketResponse)(payload));
      },
      socketReset: function socketReset() {
        return dispatch((0, _actions2.socketReset)());
      },
      socketLoading: function socketLoading(payload) {
        return dispatch((0, _actions2.socketLoading)(payload));
      },
      socketPDFResponse: function socketPDFResponse(payload) {
        return dispatch((0, _actions2.socketPDFResponse)(payload));
      },
      socketXLSXResponse: function socketXLSXResponse(payload) {
        return dispatch((0, _actions2.socketXLSXResponse)(payload));
      },
      socketLoadingForRecord: function socketLoadingForRecord(payload) {
        return dispatch((0, _actions2.socketLoadingForRecord)(payload));
      },
      socketResetForRecord: function socketResetForRecord(payload) {
        return dispatch((0, _actions2.socketResetForRecord)(payload));
      }
    };
  } else if (process.env.REACT_APP_CLIENT === "tenant") {
    handleActions = {
      socketResponse: function socketResponse(payload) {
        return dispatch((0, _actions.socketResponseForTenant)(payload));
      },
      socketReset: function socketReset() {
        return dispatch((0, _actions.socketResetForTenant)());
      },
      socketLoading: function socketLoading(payload) {
        return dispatch((0, _actions.socketLoadingForTenant)(payload));
      },
      socketPDFResponse: function socketPDFResponse(payload) {
        return dispatch((0, _actions.socketPDFResponseForTenant)(payload));
      },
      socketXLSXResponse: function socketXLSXResponse(payload) {
        return dispatch((0, _actions.socketXLSXResponseForTenant)(payload));
      }
    };
  }
  var Toast = {
    success: function success(data) {
      toastProperties = {
        id: id,
        title: data !== null && data !== void 0 && data.title ? data === null || data === void 0 ? void 0 : data.title : "Success",
        description: data === null || data === void 0 ? void 0 : data.description,
        backgroundColor: "#5cb85c",
        icon: _check.default,
        button: data !== null && data !== void 0 && data.button ? data === null || data === void 0 ? void 0 : data.button : false,
        click: data === null || data === void 0 ? void 0 : data.handleClick
      };
      setList([toastProperties]);
    },
    danger: function danger(data) {
      toastProperties = {
        id: id,
        title: data !== null && data !== void 0 && data.title ? data === null || data === void 0 ? void 0 : data.title : "Error",
        description: data === null || data === void 0 ? void 0 : data.description,
        backgroundColor: "#d9534f",
        icon: _error.default,
        button: data !== null && data !== void 0 && data.button ? data === null || data === void 0 ? void 0 : data.button : false,
        click: data === null || data === void 0 ? void 0 : data.handleClick
      };
      setList([toastProperties]);
    },
    info: function info(data) {
      toastProperties = {
        id: id,
        title: data !== null && data !== void 0 && data.title ? data === null || data === void 0 ? void 0 : data.title : "Info",
        description: data === null || data === void 0 ? void 0 : data.description,
        backgroundColor: "#5bc0de",
        icon: _info.default,
        button: data !== null && data !== void 0 && data.button ? data === null || data === void 0 ? void 0 : data.button : false,
        click: data === null || data === void 0 ? void 0 : data.handleClick
      };
      setList([toastProperties]);
    },
    warning: function warning(data) {
      toastProperties = {
        id: id,
        title: data !== null && data !== void 0 && data.title ? data === null || data === void 0 ? void 0 : data.title : "Alert",
        description: data === null || data === void 0 ? void 0 : data.description,
        backgroundColor: "#f0ad4e",
        icon: _warning.default,
        button: data !== null && data !== void 0 && data.button ? data === null || data === void 0 ? void 0 : data.button : false,
        click: data === null || data === void 0 ? void 0 : data.handleClick
      };
      setList([toastProperties]);
    }
  };
  var ProgressToaster = {
    success: function success(data) {
      var _localStorage;
      (0, _Socket.onConnect)(data, Toast, handleActions, allStates, (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("skipBulkOperation"), ProgressToaster);
    }
  };
  var ToastContainer = function ToastContainer() {
    if (isloading && list.length === 0) {
      var _document$getElements;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "spinner-border-loader"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _loader2x.default
      })), ((_document$getElements = document.getElementsByClassName("modal-backdrop")) === null || _document$getElements === void 0 ? void 0 : _document$getElements.length) === 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-backdrop-notification opacity-less loader-backdrop"
      }));
    }
    var handleCloseToaster = function handleCloseToaster(newId, toast) {
      deleteToast(newId);
      if (typeof (toast === null || toast === void 0 ? void 0 : toast.click) === "function") {
        toast === null || toast === void 0 ? void 0 : toast.click();
      }
      setAutoClose(100);
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NotificationContainer.default, {
      list: list,
      position: position,
      handleCloseToaster: handleCloseToaster
    }), process.env.REACT_APP_CLIENT === "dashboard" && /*#__PURE__*/_react.default.createElement(_SocketContainer.default, {
      info: loadingList === null || loadingList === void 0 ? void 0 : loadingList.filter(function (el) {
        return !el.isHide;
      }),
      position: position,
      handleHideModal: function handleHideModal(newId) {
        return dispatch((0, _actions2.socketMinimizeProcess)(newId));
      }
    }), process.env.REACT_APP_CLIENT === "dashboard" && /*#__PURE__*/_react.default.createElement(_SocketContainer.default, {
      info: loadingListForRecord === null || loadingListForRecord === void 0 ? void 0 : loadingListForRecord.filter(function (el) {
        return !el.isHide;
      }),
      position: position,
      handleHideModal: function handleHideModal(newId) {
        return dispatch((0, _actions2.socketMinimizeProcess)(newId));
      }
    }), !localStorage.getItem("skipBulkOperation") && process.env.REACT_APP_CLIENT === "tenant" && /*#__PURE__*/_react.default.createElement(_SocketContainer.default, {
      info: loadingList === null || loadingList === void 0 ? void 0 : loadingList.filter(function (el) {
        return !el.isHide;
      }),
      position: position,
      handleHideModal: function handleHideModal(newId) {
        return dispatch((0, _actions.socketMinimizeProcessForTenant)(newId));
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement(AuthContext.Provider, {
    value: {
      Toast: Toast,
      Loader: Loader,
      setAutoClose: setAutoClose,
      deleteToast: deleteToast,
      ProgressToaster: ProgressToaster
    }
  }, /*#__PURE__*/_react.default.createElement(_core.WithAxios, null, children), ToastContainer());
}
function useNotification() {
  var context = (0, _react.useContext)(AuthContext);
  if (context === undefined) {
    throw new Error("useNotification must be used within a NotificationProvider");
  }
  return context;
}